import React from 'react';

const StatusToggle = ({ status, onChange, disabled = false, loading = false }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled && !loading) {
      onChange(!status);
    }
  };

  return (
    <div className="flex items-center justify-center h-full w-full" onClick={(e) => e.stopPropagation()}>
      <label className={`relative inline-block w-12 h-6 ${disabled || loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
        <input
          type="checkbox"
          checked={status}
          onChange={handleClick}
          disabled={disabled || loading}
          className="sr-only peer"
        />
        <span className={`absolute inset-0 bg-gray-300 rounded-full transition-colors peer-checked:bg-green-500 ${
          loading ? 'animate-pulse' : ''
        }`}>
          <span className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform ${
            status ? 'translate-x-6' : ''
          }`}></span>
        </span>
      </label>
    </div>
  );
};

export default StatusToggle;
